export default {
  components: {
    titleSettings: {
      fontWeight: 'bold',
      textColor: 'primary-13',
      marginBottom: '3',
      fontSize: '10',
    },
    filters: {
      bgColor: 'primary',
      paddingBottom: '35px',
      paddingTop: '3',
      paddingWidth: '2',
      marginLeft: '0',
      marginRight: '0',
    },
    locationSelector: {
      labelKey: 'cmp-preposition--origin-place',
      leftIcon: 'icon icon-marker',
      inputItem: {
        placeholder: 'cmp-preposition--origin-place',
        bgColor: 'white',
        textLabel: {
          fontWeight: 'normal',
          textColor: 'white',
        },
        leftIconsProps: {
          color: 'white',
          iconProps: {
            textColor: 'secondary',
          },
        },
      },
    },
    search: {
      color: 'secondary',
      roundedTopRight: '@theme:button.rounded',
      roundedBottomRight: '@theme:button.rounded',
      fontSize: '17px',
    },
    list: {
      itemSettings: {
        open: true,
        showSpecialInstructions: false,
        showTicketTypes: false,
        addressStyles: {
          titleStyles: {
            leftIconStyles: {
              textColor: 'secondary',
              fontSize: '4',
            },
          },
        },
        telephoneNumbersStyles: {
          titleStyles: {
            leftIconStyles: {
              textColor: 'secondary',
              fontSize: '4',
            },
          },
        },
        hoursOperationStyles: {
          titleStyles: {
            leftIconStyles: {
              textColor: 'secondary',
              fontSize: '4',
            },
          },
        },
        callToActionStyles: {
          textColor: 'primary',
          fontWeight: 'bold',
          style: {
            textDecoration: 'none',
          },
        },
      },
    },
    bookNowSettings: {
      color: 'secondary',
      textTransform: 'Capitalize',
      roundedTopRight: '@theme:button.rounded',
      roundedBottomRight: '@theme:button.rounded',
      paddingWidth: '5',
      paddingHeight: '2',
      fontSize: '17px',
    },
    map: {
      heightContainer: '100%',
      style: {
        height: '650px',
      },
    },
  },
  uiDisplay: {
    showDestination: false,
  },
  prePopulation: {
    locationSearchOptions: {
      outputCategory: ['STATIONS'],
    },
  },
};
